var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.0034722px",
    height: "16.0034722px",
    viewBox: "0 0 16.0034722 16.0034722",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4097222,1.75 C15.8055556,2.14583333 16.0034722,2.61979167 16.0034722,3.171875 C16.0034722,3.72395833 15.8055556,4.19791667 15.4097222,4.59375 L4.40972222,15.59375 L0.847222222,16 C0.597222222,16.0208333 0.388888889,15.9479167 0.222222222,15.78125 C0.0555555556,15.6145833 -0.0173611111,15.40625 0.00347222222,15.15625 L0.409722222,11.59375 L11.4097222,0.59375 C11.8055556,0.197916667 12.2795139,0 12.8315972,0 C13.3836806,0 13.8576389,0.197916667 14.2534722,0.59375 L15.4097222,1.75 Z M12.4409722,6.15625 L9.84722222,3.5625 L2.84722222,10.5625 L3.94097222,10.5625 L3.94097222,12.0625 L5.44097222,12.0625 L5.44097222,13.15625 L12.4409722,6.15625 Z M3.94097222,14.65625 L4.56597222,14.03125 L4.56597222,12.9375 L3.06597222,12.9375 L3.06597222,11.4375 L1.97222222,11.4375 L1.34722222,12.0625 L1.15972222,13.90625 L2.09722222,14.84375 L3.94097222,14.65625 Z M14.7222222,3.875 C14.9097222,3.6875 15.0034722,3.453125 15.0034722,3.171875 C15.0034722,2.890625 14.9097222,2.65625 14.7222222,2.46875 L13.5347222,1.28125 C13.3472222,1.09375 13.1128472,1 12.8315972,1 C12.5503472,1 12.3159722,1.09375 12.1284722,1.28125 L10.5659722,2.84375 L13.1597222,5.4375 L14.7222222,3.875 Z",
    id: "Shape",
    fill: "#212529",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.c97f5ed561c28b54ade259475c02056e.svg";
export { ForwardRef as ReactComponent };